import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { DsBannerState } from '@levelaccess/design-system';

import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { UserAclService } from '../../services/user-acl.service';
import { AclSecurityAdapter } from '../../services/acl.service';
import { RequiredSecurities } from '../../../../shared/constants/required-securities';
import { FeatureFlagCollection } from '../../../../shared/interfaces/feature-flag.interface';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-scanning-agent-switch',
  templateUrl: './scanning-agent-switch.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SharedModule],
})
export class ScanningAgentSwitchComponent implements OnInit, OnDestroy {
  @Input() public value: boolean = false;

  @Output() public valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public scanningAgentFeatureEnabled: boolean = false;
  public cannotToggleScanningAgent$: Observable<boolean>;
  public canSeeScanningAgent$: Observable<boolean>;

  private subscriptions: Subscription = new Subscription();
  protected readonly DsBannerState: typeof DsBannerState = DsBannerState;

  constructor(
    private featureFlagService: FeatureFlagService,
    private userAclService: UserAclService,
  ) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.featureFlagService.variation$(FeatureFlagCollection.scanningAgent, false).subscribe((enabled: boolean) => {
        this.scanningAgentFeatureEnabled = enabled;
      }),
    );

    this.canSeeScanningAgent$ = this.userAclService
      .createCheckAccessForCurrentUser()
      .pipe(
        map((adapter: AclSecurityAdapter) =>
          adapter.useFunctionalActions(RequiredSecurities.ScanningAgent_Read.functionalActions).check(),
        ),
      );

    this.cannotToggleScanningAgent$ = this.userAclService
      .createCheckAccessForCurrentUser()
      .pipe(
        map(
          (adapter: AclSecurityAdapter) =>
            !adapter.useFunctionalActions(RequiredSecurities.ScanningAgent_Create.functionalActions).check(),
        ),
      );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onValueChange(newValue: boolean): void {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
